import { FC, memo } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Grid } from '@mui/material';

import { RemoveButton } from 'components/_basic/Form/FieldArray/components/RemoveButton';
import { TextInputControl } from 'components/_basic/Form/TextInput';
import { Responsive } from 'components/_basic/Responsive';
import { ISectionRowProps as IProps } from 'components/BusinessToolForm';

import { concatWithDot } from 'helpers/string';

import { INSTITUTION_NAMES } from '../../utils/form';

export const EducationForm: FC<IProps> = memo(({ name, disabled = false, onRemove }) => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  return (
    <>
      <Grid container spacing={{ xs: '16px', md: '16px' }}>
        <Grid item xs={12} md={6}>
          <TextInputControl
            control={control}
            id={concatWithDot(name, INSTITUTION_NAMES.NAME)}
            name={concatWithDot(name, INSTITUTION_NAMES.NAME)}
            label={t('management.team.nameOfInstitution')}
            disabled={disabled}
            maxLength={150}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextInputControl
            control={control}
            id={concatWithDot(name, INSTITUTION_NAMES.SPECIALIZATION)}
            name={concatWithDot(name, INSTITUTION_NAMES.SPECIALIZATION)}
            label={t('management.team.specialization')}
            disabled={disabled}
            maxLength={150}
          />
        </Grid>
        <Responsive mobile>
          <Grid item xs={12}>
            <RemoveButton disabled={disabled} onClick={onRemove} canRemove>
              Delete
            </RemoveButton>
          </Grid>
        </Responsive>
      </Grid>
    </>
  );
});
